import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $integrationsStore, $profileFeatureStore, $profileStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import { UserType } from '@shared/api';
import { IntegrationList } from './widgets';
import { PageContainer, View } from '@widgets';

export const IntegrationsPage = () => {
  const { navigate } = useRouteHook();

  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const profileStore = useUnit($profileStore.store);
  const integrationsStore = useUnit($integrationsStore.store);

  const { t } = useTranslation('integrations');

  useEffect(() => {
    if (!profileStore.data?.userType) return;
    if (
      profileStore.data?.userType !== UserType.Admin ||
      !profileFeatureStore.data?.accountFlows?.some((accountFlow) => accountFlow.integrations) ||
      PaletteUtils.isPersonalPalette
    ) {
      navigate(RoutePaths.dashboard.onNavigate());
      return;
    }

    $integrationsStore.events.getInitialIntegrations();
    return () => $integrationsStore.events.clear();
  }, [profileStore.data?.userType]);

  return (
    <PageContainer title={t('title')} header={t('header')}>
      <View
        loading={integrationsStore.loading}
        error={integrationsStore.error}
        noData={!integrationsStore.data.length}
        onRefresh={() => $integrationsStore.events.getInitialIntegrations()}
      >
        <IntegrationList list={integrationsStore.data} />
      </View>
    </PageContainer>
  );
};
